import axios from 'axios'
import axiosRetry from 'axios-retry'
import router from 'router'
import store from 'vuex/store.js'

axios.interceptors.request.use(function (config) {
  if (!store.getters.loggedIn) {
    router.push({name: 'Logout'})
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

export const http = axios.create({
  /* LOCAL */
  /* baseURL: `http://localhost:7071/api/v1`, */
  /* DEV */
  baseURL: `https://vitzdev.azurewebsites.net/api/v1`,
  /* TEST */
  /* baseURL: `https://vitztest.azurewebsites.net/api/v1`, */
  /* PROD */
  /* baseURL: `https://vitzprod.azurewebsites.net/api/v1`, */
  /* DEMO */
  /* baseURL: `https://vitzdemo.azurewebsites.net/api/v1`, */
  headers: {
    /* DEV */
    'x-functions-key': 'elNmkIPtsqLinVpywaViW2UYO79Lfo/vaye9LwQ8Gdl8tPawcoD69A=='
    /* TEST */
    /* 'x-functions-key': 'aZevJvIcb4jnNxTsUwTmm2332kjOzVEQznlM2UETuk5Dstaefv/djQ==' */
    /* PROD */
    /* 'x-functions-key': 'TfUC2wssV9aEsr8fzdMDj3ZwWFNoGar39hJ/KXEowU6uu6aYBra3Eg==' */
    /* DEMO */
    /* 'x-functions-key': '' */
  }
})

export const httpi = axios.create({
  /* TEST */
  /* baseURL: `https://dinet-e-tracking-test.azurewebsites.net/api/v1`, */
  /* PROD */
  /* baseURL: `https://dinet-e-tracking.azurewebsites.net/api/v1`, */
  headers: {
    /* TEST */
    /* 'x-functions-key': 'OWwm8cT-gTyjFILAITrAcOoUnIerg5umsiil0KMI9WcGAzFuVb-FNg==' */
    /* PROD */
    /* 'x-functions-key': 'Di5AG8wPV3zZhyAiQqMai8DjPhLG-EWJ0lRQMSlhzNcFAzFut_Dtfw==' */
  }
})

axiosRetry(httpi, { retries: 1, retryCondition: () => true })



// WEBPACK FOOTER //
// ./src/lib/httpAxios.js